export const TRANSLATION_SCOPE = 'filterGroupGridModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
